/* eslint-disable @typescript-eslint/no-var-requires */
import { Button, Modal } from 'antd';
import React, {
  FunctionComponent,
  MutableRefObject,
  useEffect,
  useRef,
  useState,
} from 'react';

import './animation042.less';
import { usePlayFlag } from './../../components/topicScroll';
import ImgPoint from '../../../../../assets/animation_point.gif';
import ImgArrowLeft from '../../../../../assets/arrow-left-long.png';
import ImgArrowRight from '../../../../../assets/arrow-right-long.png';

interface IAnimation042SubItem {
  img: string;
  title: string;
  content: string;
}

interface IAnimation042Item {
  icon: string;
  text: string;
  subtitle?: string;
  subItems?: IAnimation042SubItem[];
}

interface IAnimation042Props {
  items: IAnimation042Item[];
  className?: string | null;
  onCompleted: () => void;
}

const Animation042: FunctionComponent<IAnimation042Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const [isModalOpen, setModalOpen] = useState(false);
  const [currPage, setCurrPage] = useState(0);
  const [modalItem, setModalItem] = useState<IAnimation042SubItem[]>();
  const [show, setShow] = useState(true);
  const [show1, setShow1] = useState(true);
  const [show2, setShow2] = useState(true);

  const setPage = (pagePlus: number) => {
    setCurrPage(currPage + pagePlus);
  };
  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation042 onCompleted');
      onCompleted && onCompleted();
    }
  };
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;

  useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };

  return (
    <div ref={crrRef} className={`animation042 component ${className}`}>
      <div className="animation042-content">
        {items.map((itm: IAnimation042Item, idx: number) => (
          <div
            onClick={() => clickToPlay()}
            key={idx}
            className={`animation042-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
          >
            <img
              className="click-point"
              onClick={() => clickToPlay()}
              style={{
                display: play <= 1 ? 'block' : 'none',
              }}
              src={ImgPoint}
              alt=""
            />
            <div className="animation042-indicate-number">
              <img src={getImg(itm.icon)} alt="" />
            </div>
            <div className="animation042-subcontent">
              <div
                className="animation042-text"
                dangerouslySetInnerHTML={{ __html: itm.text }}
              />
              {itm.subtitle ? (
                <div className="text sub-task-text">
                  <Button
                    style={{ fontSize: '1.4rem' }}
                    type="link"
                    onClick={(e) => {
                      e.stopPropagation();
                      setModalOpen(true);
                      setModalItem(itm.subItems);
                      setShow2(false);
                    }}
                  >
                    {itm.subtitle}
                    <img
                      className="click-point1"
                      hidden={!show2}
                      src={ImgPoint}
                      alt=""
                    />
                  </Button>
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>
      {modalItem && (
        <Modal
          width="80%"
          className="animation042-modal"
          title={
            <div className="animation042-modal-header">
              {modalItem[currPage]?.title}
            </div>
          }
          footer={null}
          visible={isModalOpen}
          onCancel={() => setModalOpen(false)}
        >
          <div className="border">
            <img
              src={
                require(`../../../../../assets/${modalItem[currPage]?.img}`)
                  .default
              }
              alt=""
            />
          </div>
          <div
            className="content"
            dangerouslySetInnerHTML={{ __html: modalItem[currPage]?.content }}
          />
          <Button
            className={`prev-button ${currPage === 0 ? 'hide' : ''}`}
            type="text"
            disabled={currPage === 0}
            onClick={() => {
              setPage(-1);
              setShow(false);
            }}
          >
            <img className="arrow" src={ImgArrowLeft} alt="" />
            <img
              className="click-point1"
              hidden={!show}
              src={ImgPoint}
              alt=""
            />
          </Button>

          <Button
            className={`next-button ${
              currPage === modalItem.length - 1 ? 'hide' : ''
            }`}
            type="text"
            disabled={currPage === modalItem.length - 1}
            onClick={() => {
              setPage(1);
              setShow1(false);
            }}
          >
            <img className="arrow" src={ImgArrowRight} alt="" />
            <img
              className="click-point2"
              hidden={!show1}
              src={ImgPoint}
              alt=""
            />
          </Button>
        </Modal>
      )}
    </div>
  );
};

export default Animation042;
